import { SITE_VARIABLES } from '../../../common/styles/variables';
import { PlayerSizesTypes } from '../../../common/store/store.types';
import {
  SEEK_BAR_HEIGHT_LARGE,
  SEEK_BAR_HEIGHT_MEDIUM,
  SEEK_BAR_HEIGHT_SMALL,
} from '../../../common/utils/common.constants';

interface StylesObject {
  seekBarContainerStyle: { [key: string]: any };
  seekBarStyle: { [key: string]: any };
  seekBarAndToolTipContainerStyle: { [key: string]: any };
  toolTipStyle: { [key: string]: any };
}

const tooltipFontSize = '10px';
const tooltipFontFamily = SITE_VARIABLES.TEXT_FONT_FAMILY.LATO;
const tooltipBackgroundColor = SITE_VARIABLES.COLORS.BLACK;
const tooltipColor = SITE_VARIABLES.COLORS.WHITE;

const seekBarContainer = {
  width: '100%',
  position: 'relative',
  height: '20px',
  cursor: 'pointer',
  display: 'block',
  pointerEvents: 'auto',
  partialVideoControls: {
    position: 'absolute',
    bottom: '0px',
  },
  ad: {
    pointerEvents: 'none',
    cursor: 'auto',
  },
  hide: {
    display: 'none',
  },
};

const seekBar = {
  width: '100%',
  position: 'absolute',
  display: 'flex',
  bottom: '0px',
  transition: '0.4s',
  flexDirection: 'row-reverse',
  backgroundColor: SITE_VARIABLES.COLORS.GRAY_TRANSPARENT,
  small: {
    height: `${SEEK_BAR_HEIGHT_SMALL}px`,
  },
  medium: {
    height: `${SEEK_BAR_HEIGHT_MEDIUM}px`,
  },
  largeAndExtraLarge: {
    height: `${SEEK_BAR_HEIGHT_LARGE}px`,
  },
};

const toolTip = {
  color: tooltipColor,
  backgroundColor: tooltipBackgroundColor,
  width: 'max-content',
  fontFamily: tooltipFontFamily,
  fontSize: tooltipFontSize,
  padding: '2px 8px',
  position: 'absolute',
  opacity: '0',
  background: tooltipBackgroundColor,
  borderRadius: SITE_VARIABLES.BORDER_RADIUS.EXTRA_TINY,
  pointerEvents: 'none',
  zIndex: '1',
  maxWidth: '388px',
  overflowWrap: 'break-word',
  wordWrap: 'break-word',
  hyphens: 'auto',
  marginBottom: '6px',
};

const seekBarAndToolTipContainer = {
  position: 'relative',
  display: 'grid',
  width: '100%',
  partialVideoControls: {
    position: 'absolute',
    bottom: '0px',
  },
};

export const getSeekBarContainerStyleObject = (playerSize: PlayerSizesTypes, desktopMode: boolean, showAdControls: boolean, clickToPlay: boolean, viewDisplay: boolean, showStoriesSeekBars: boolean, isFullScreen: boolean): StylesObject => {
  const smallSize = playerSize === 'small';
  const mediumSize = playerSize === 'medium';
  const largeAndExtraLargeSize = playerSize === 'large' || playerSize === 'extraLarge';
  const partialVideoControls = smallSize || (mediumSize && showAdControls) || (viewDisplay && !isFullScreen);

  return ({
    seekBarContainerStyle: [
      seekBarContainer,
      !desktopMode && partialVideoControls && seekBarContainer.partialVideoControls,
      clickToPlay && seekBarContainer.hide,
      showAdControls && seekBarContainer.ad,
      showStoriesSeekBars && seekBarContainer.hide,
    ],
    seekBarStyle: [
      seekBar,
      smallSize && seekBar.small,
      mediumSize && seekBar.medium,
      largeAndExtraLargeSize && seekBar.largeAndExtraLarge,
    ],
    seekBarAndToolTipContainerStyle: [
      seekBarAndToolTipContainer,
      partialVideoControls && seekBarAndToolTipContainer.partialVideoControls,
    ],
    toolTipStyle: {
      ...toolTip,
    },
  });
};
